import React from "react";

function Subscribe() {
  return (
    <section class="subscribe is-large">
      <div className="sub-sec">
        <h1>Subscribe</h1>
        <br></br>
      </div>
      <div className="sub-sec">
        <h1>To Receive A Free Copy Of Our E-Book</h1>
      </div>
      <div className="sub-sec">
        <input class="input" id="sub-sec" placeholder="Email" />
        <button class="button is-black">SignUp</button>
      </div>
    </section>
  );
}

export default Subscribe;
